<template>
  <div>
    <Movementmenu />
    <v-container fluid class="grey lighten-4 pa-6">
      <!-- Dashboard Stats -->
      <v-row dense class="mb-4">
        <v-col cols="12" sm="6" md="3">
          <v-card
            class="rounded-lg shadow-sm cursor-pointer"
            color="primary"
            dark
            hover
            @click="transference_personnelQueryAll"
          >
            <v-list-item two-line>
              <v-list-item-content>
                <div class="overline mb-1">ผู้เสนอย้ายทั้งหมด</div>
                <v-list-item-title class="headline font-weight-bold">
                  {{ transference_personnelCount.sumAll || 0 }}
                  <small class="caption">ราย</small>
                </v-list-item-title>
              </v-list-item-content>
              <v-avatar size="50" color="primary lighten-1">
                <v-icon size="30">mdi-account-group</v-icon>
              </v-avatar>
            </v-list-item>
          </v-card>
        </v-col>

        <v-col cols="12" sm="6" md="3">
          <v-card
            class="rounded-lg shadow-sm cursor-pointer"
            color="success"
            dark
            hover
            @click="showSuccessPosition"
          >
            <v-list-item two-line>
              <v-list-item-content>
                <div class="overline mb-1">รายการที่สำเร็จแล้ว</div>
                <v-list-item-title class="headline font-weight-bold">
                  {{ transference_personnelCount.sumsuc || 0 }}
                  <small class="caption">ราย</small>
                </v-list-item-title>
              </v-list-item-content>
              <v-avatar size="50" color="success lighten-1">
                <v-icon size="30">mdi-check-decagram</v-icon>
              </v-avatar>
            </v-list-item>
          </v-card>
        </v-col>

        <v-col cols="12" sm="6" md="3">
          <v-card class="rounded-lg shadow-sm" color="info" dark>
            <v-list-item two-line>
              <v-list-item-content>
                <div class="overline mb-1">แนบไฟล์สมบูรณ์</div>
                <v-list-item-title class="headline font-weight-bold">
                  {{ transference_personnelCount.sumdoc || 0 }}
                  <small class="caption">ราย</small>
                </v-list-item-title>
              </v-list-item-content>
              <v-avatar size="50" color="info lighten-1">
                <v-icon size="30">mdi-file-document-check</v-icon>
              </v-avatar>
            </v-list-item>
          </v-card>
        </v-col>

        <v-col cols="12" sm="6" md="3">
          <v-card
            class="rounded-lg shadow-sm cursor-pointer"
            color="warning darken-2"
            dark
            hover
            @click="SearchCCdoc"
          >
            <v-list-item two-line>
              <v-list-item-content>
                <div class="overline mb-1">แจ้งขอยกเลิกไฟล์</div>
                <v-list-item-title class="headline font-weight-bold">
                  {{ transference_personnelCount.sumcc || 0 }}
                  <small class="caption">ราย</small>
                </v-list-item-title>
              </v-list-item-content>
              <v-avatar size="50" color="warning darken-1">
                <v-icon size="30">mdi-file-cancel</v-icon>
              </v-avatar>
            </v-list-item>
          </v-card>
        </v-col>

        <v-col cols="12" sm="6" md="3">
          <v-card
            class="rounded-lg shadow-sm cursor-pointer"
            color="error darken-2"
            dark
            hover
            @click="SearchPVCCCdoc"
          >
            <v-list-item two-line>
              <v-list-item-content>
                <div class="overline mb-1">แจ้งขอยกเลิกไฟล์ สอจ.</div>
                <v-list-item-title class="headline font-weight-bold">
                  {{ transference_personnelCount.sumpvccc || 0 }}
                  <small class="caption">ราย</small>
                </v-list-item-title>
              </v-list-item-content>
              <v-avatar size="50" color="error darken-1">
                <v-icon size="30">mdi-file-cancel</v-icon>
              </v-avatar>
            </v-list-item>
          </v-card>
        </v-col>

        <!-- Additional Stats & Actions -->
        <v-col cols="12" sm="12" md="9">
          <v-card   
            dark
            hover
               class="rounded-lg shadow-sm pa-5"
          >
            <div class="d-flex flex-wrap align-center" style="gap: 10px;">
              <v-chip color="" class="shadow-sm" label>
                <v-icon left color="info">mdi-school</v-icon> เงื่อนไข 4 ปี:
                <strong class="ml-1">{{
                  transference_personnelCount.conditions || 0
                }}</strong>
              </v-chip>
              <v-chip color="" class="shadow-sm" label>
                <v-icon left color="secondary">mdi-home-city</v-icon> ครูคืนถิ่น:
                <strong class="ml-1">{{
                  transference_personnelCount.localDevs || 0
                }}</strong>
              </v-chip>
              <v-chip color="" class="shadow-sm" label>
                <v-icon left color="primary">mdi-map-marker-star</v-icon>
                จชต.:
                <strong class="ml-1">{{
                  transference_personnelCount.sounths || 0
                }}</strong>
              </v-chip>
              <v-spacer></v-spacer>
              <v-btn
                small
                rounded
                color="error"
                outlined
                @click="clearRecordDontSave"
              >
                <v-icon left>mdi-delete-sweep</v-icon> ลบรายการขยะ
              </v-btn>
              <v-btn
                small
                rounded
                color="warning"
                outlined
                @click="optimizeData"
              >
                <v-icon left>mdi-database-refresh</v-icon> จัดระเบียบข้อมูล
              </v-btn>
            </div>
          </v-card>
        </v-col>
      </v-row>

      <!-- Main Data Table Card -->
      <base-material-card
        icon="mdi-account-details"
        title="จัดการข้อมูลการย้าย (สายการสอนและสนับสนุน)"
        color="primary"
        class="px-5 py-3"
      >
        <!-- Toolbar -->
        <v-card flat class="grey lighten-5 rounded-lg mb-4 pa-4">
          <v-row align="center">
            <v-col cols="12" md="8" class="d-flex flex-wrap" style="gap: 10px;">
              <v-btn small rounded color="success" @click="exportToExcel">
                <v-icon left>mdi-file-excel</v-icon> ส่งออก Excel
              </v-btn>

              <v-menu offset-y>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    small
                    rounded
                    color="info"
                    outlined
                    v-bind="attrs"
                    v-on="on"
                  >
                    <v-icon left>mdi-printer</v-icon> พิมพ์รายงาน
                  </v-btn>
                </template>
                <v-list dense>
                  <v-list-item
                    link
                    :href="
                      `#/admin/print_assess1420/${periods.period_times}/${periods.period_year}`
                    "
                    target="_blank"
                  >
                    <v-list-item-title
                      >แบบประเมินคะแนน 1.4 (1)</v-list-item-title
                    >
                  </v-list-item>
                  <v-list-item
                    link
                    :href="
                      `#/admin/print_assess1420detail/${periods.period_times}/${periods.period_year}`
                    "
                    target="_blank"
                  >
                    <v-list-item-title
                      >แบบประเมินคะแนน 1.4 (2)</v-list-item-title
                    >
                  </v-list-item>
                </v-list>
              </v-menu>

              <v-btn
                small
                rounded
                color="warning"
                @click="Searchtemporary"
                outlined
              >
                <v-icon left>mdi-content-save-alert</v-icon> กรอง: ยังไม่บันทึก
              </v-btn>
            </v-col>

            <v-col cols="12" md="4">
              <v-text-field
                v-model="search"
                prepend-inner-icon="mdi-magnify"
                label="ค้นหา (ชื่อ, สังกัด, จังหวัด...)"
                outlined
                dense
                rounded
                hide-details
                class="bg-white"
                clearable
              ></v-text-field>
            </v-col>

            <v-col cols="12">
              <v-select
                v-model="selectedHeaders"
                :items="headers"
                label="แสดง/ซ่อน คอลัมน์"
                multiple
                outlined
                dense
                return-object
                small-chips
                hide-details
                class="bg-white"
              >
                <template v-slot:selection="{ index }">
                  <span v-if="index === 0" class="caption grey--text">
                    เลือกคอลัมน์ที่จะแสดง ({{ selectedHeaders.length }} คอลัมน์)
                  </span>
                </template>
              </v-select>
            </v-col>
          </v-row>
        </v-card>

        <!-- Data Table -->
        <v-data-table
          :headers="showHeaders"
          :items="transference_personnels"
          :search="search"
          :loading="loading"
          item-key="tid_ref"
          class="elevation-0 custom-table"
          :items-per-page="15"
          :footer-props="{
            'items-per-page-options': [10, 15, 25, 50, 100, -1],
            'items-per-page-text': 'แถวต่อหน้า:'
          }"
        >
          <!-- Custom Slots -->
          <template v-slot:item.transfer_status="{ item }">
            <v-chip
              small
              :color="item.transfer_status === 'save' ? 'success' : 'warning'"
              dark
              label
              @click="
                item.transfer_status !== 'save'
                  ? changeStatus(item.tid_ref)
                  : null
              "
              :style="item.transfer_status !== 'save' ? 'cursor: pointer;' : ''"
            >
              <v-icon left small>
                {{
                  item.transfer_status === "save"
                    ? "mdi-check-circle"
                    : "mdi-clock-alert"
                }}
              </v-icon>
              {{
                item.transfer_status === "save" ? "บันทึกแล้ว" : "ยังไม่บันทึก"
              }}
            </v-chip>
          </template>

          <template v-slot:item.updateFileDoc="{ item }">
            <v-icon v-if="item.documentsLinkfile" color="success" size="20">
              mdi-check-circle
            </v-icon>
            <v-btn
              v-else
              x-small
              color="warning"
              outlined
              @click="updateFileDoc(item.tid_ref)"
            >
              <v-icon left x-small>mdi-paperclip</v-icon>
              แนบไฟล์
            </v-btn>
          </template>

          <template v-slot:item.comment_dr_c="{ item }">
            <v-chip
              x-small
              :color="getCommentColor(item.comment_dr_c)"
              dark
              @click.stop="comment_idPosition(item.tid_ref)"
              class="cursor-pointer"
            >
              {{ getCommentText(item.comment_dr_c) }}
            </v-chip>
          </template>

          <template v-slot:item.tp_comment_dr_stb="{ item }">
            <v-chip
              x-small
              :color="getCommentColor(item.tp_comment_dr_stb)"
              dark
              @click.stop="tp_comment_dr_stbPosition(item.tid_ref)"
              class="cursor-pointer"
            >
              {{ getCommentText(item.tp_comment_dr_stb) }}
            </v-chip>
          </template>

          <template v-slot:item.documentsLinkfile="{ item }">
            <div
              v-if="item.documentsLinkfile"
              class="d-flex align-center justify-center"
            >
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    icon
                    small
                    color="primary"
                    @click="viewdocumentsLinkfile(item.documentsLinkfile)"
                    v-bind="attrs"
                    v-on="on"
                  >
                    <v-icon>mdi-file-eye</v-icon>
                  </v-btn>
                </template>
                <span>ดูไฟล์</span>
              </v-tooltip>
              <v-icon
                v-if="item.ccDocumentFile === 'cc'"
                color="error"
                small
                class="ml-1"
              >
                mdi-alert-circle
              </v-icon>
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                    color="error lighten-2"
                    small
                    class="ml-1 pointer"
                    @click.stop="CancelFilePDF(item.tid_ref)"
                    v-bind="attrs"
                    v-on="on"
                  >
                    mdi-close-circle
                  </v-icon>
                </template>
                <span>ลบไฟล์</span>
              </v-tooltip>
            </div>
            <span v-else class="grey--text caption">-</span>
          </template>

          <template v-slot:item.tpvecprovince_scoreFile="{ item }">
            <div
              v-if="item.tpvecprovince_scoreFile"
              class="d-flex align-center justify-center"
            >
              <v-icon color="error" large v-if="item.ccDocumentFilePVC === 'cc'">
                mdi-information
              </v-icon>

              <v-btn
                icon
                small
                color="info"
                :href="'/HRvecfiles/' + item.tpvecprovince_scoreFile"
                target="_blank"
              >
                <v-icon>mdi-file-percent</v-icon>
              </v-btn>
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                    color="error lighten-2"
                    small
                    class="ml-1 pointer"
                    @click.stop="CancelFilePDFProvince(item.tid_ref)"
                    v-bind="attrs"
                    v-on="on"
                  >
                    mdi-close-circle
                  </v-icon>
                </template>
                <span>ลบไฟล์</span>
              </v-tooltip>
            </div>
            <span v-else class="grey--text caption">-</span>
          </template>

          <template v-slot:item.actions="{ item }">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-if="item.succ_college >= 1"
                  icon
                  small
                  color="error"
                  @click.stop="deletePosition(item.tid_ref)"
                  v-bind="attrs"
                  v-on="on"
                >
                  <v-icon>mdi-delete-restore</v-icon>
                </v-btn>
                <v-btn
                  v-else
                  icon
                  small
                  color="info"
                  @click.stop="select_idPosition(item.tid_ref)"
                  v-bind="attrs"
                  v-on="on"
                >
                  <v-icon>mdi-account-arrow-right</v-icon>
                </v-btn>
              </template>
              <span>{{
                item.succ_college >= 1 ? "ยกเลิกการย้าย" : "จัดสรรตำแหน่ง"
              }}</span>
            </v-tooltip>
          </template>

          <template v-slot:item.MoveCut="{ item }">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-if="item.succ_college >= 1"
                  icon
                  small
                  color="error"
                  @click.stop="deletePosition(item.tid_ref)"
                  v-bind="attrs"
                  v-on="on"
                >
                  <v-icon>mdi-delete-restore</v-icon>
                </v-btn>
                <v-btn
                  v-else
                  icon
                  small
                  color="primary"
                  @click.stop="select_idPositionMoveCut(item.tid_ref)"
                  v-bind="attrs"
                  v-on="on"
                >
                  <v-icon>mdi-content-cut</v-icon>
                </v-btn>
              </template>
              <span>{{ item.succ_college >= 1 ? "ยกเลิก" : "ตัดโอน" }}</span>
            </v-tooltip>
          </template>

          <template v-slot:item.del="{ item }">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  icon
                  small
                  color="grey"
                  @click.stop="deletetpteach(item.tid_ref)"
                  v-bind="attrs"
                  v-on="on"
                >
                  <v-icon>mdi-delete</v-icon>
                </v-btn>
              </template>
              <span>ลบรายการ</span>
            </v-tooltip>
          </template>

          <template v-slot:item.score_1420="{ item }">
            <v-text-field
              v-model="item.score_1420"
              dense
              hide-details
              outlined
              style="width: 80px"
              type="number"
              min="0"
              max="100"
              @change="updateScore1420(item.id_tfp, item.score_1420)"
            ></v-text-field>
          </template>

          <template v-slot:item.actionReceipt="{ item }">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-icon
                  v-if="item.tp14receipt === 'success'"
                  color="success"
                  @click="actionReceiptUpdate(item.id_tfp)"
                  class="cursor-pointer"
                  v-bind="attrs"
                  v-on="on"
                >
                  mdi-checkbox-marked-circle
                </v-icon>
                <v-icon
                  v-else
                  color="grey lighten-1"
                  @click="actionReceipts(item.id_tfp)"
                  class="cursor-pointer"
                  v-bind="attrs"
                  v-on="on"
                >
                  mdi-checkbox-blank-circle-outline
                </v-icon>
              </template>
              <span>{{
                item.tp14receipt === "success" ? "ยกเลิก" : "รับเรื่อง"
              }}</span>
            </v-tooltip>
          </template>
        </v-data-table>
      </base-material-card>

      <!-- ===== DIALOGS ===== -->

      <!-- Normal Transfer Dialog -->
      <v-dialog v-model="positiondialog" persistent max-width="900px">
        <v-card class="rounded-lg">
          <v-toolbar color="primary" dark flat>
            <v-icon left>mdi-account-switch</v-icon>
            <v-toolbar-title>เลือกตำแหน่งปลายทาง</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn icon @click="positiondialog = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-toolbar>
          <v-card-text class="pa-4">
            <v-row>
              <v-col cols="12" md="6">
                <v-card outlined class="pa-3">
                  <div class="subtitle-2 primary--text mb-2">
                    ข้อมูลผู้ขอย้าย
                  </div>
                  <div class="text-h6">
                    {{ transference_personnels_id_ref.personnel_name }}
                  </div>
                  <v-divider class="my-2"></v-divider>
                  <div class="caption mb-1">
                    <v-icon small>mdi-badge-account</v-icon>
                    ตำแหน่งปัจจุบัน:
                    <strong>{{
                      transference_personnels_id_ref.id_position
                    }}</strong>
                  </div>
                  <div class="caption">
                    <v-icon small>mdi-office-building</v-icon>
                    สังกัด:
                    <strong>{{
                      transference_personnels_id_ref.college_name
                    }}</strong>
                  </div>
                </v-card>
              </v-col>
              <v-col cols="12" md="6">
                <v-card outlined class="pa-3 bg-light-blue">
                  <div class="subtitle-2 info--text text--darken-3 mb-2">
                    เลือกปลายทาง
                  </div>
                  <v-autocomplete
                    :items="colleges"
                    item-text="college_name"
                    item-value="college_code"
                    v-model="updatepositions.ctscollege_code"
                    label="วิทยาลัยปลายทาง"
                    outlined
                    dense
                    bg-color="white"
                    prepend-inner-icon="mdi-school"
                    @change="man_powerQuery()"
                  ></v-autocomplete>
                  <v-autocomplete
                    :items="man_powers"
                    item-text="college_position_case"
                    item-value="id_position"
                    label="เลขที่ตำแหน่งว่าง"
                    v-model="updatepositions.ctsid_position"
                    outlined
                    dense
                    bg-color="white"
                    prepend-inner-icon="mdi-numeric"
                    :disabled="!updatepositions.ctscollege_code"
                    :loading="loadingPositions"
                  ></v-autocomplete>
                </v-card>
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions class="justify-end pa-4">
            <v-btn text @click="positiondialog = false">
              <v-icon left>mdi-close</v-icon>
              ยกเลิก
            </v-btn>
            <v-btn
              color="success"
              depressed
              @click="updatepositionSubmit"
              :disabled="
                !updatepositions.ctscollege_code ||
                  !updatepositions.ctsid_position
              "
            >
              <v-icon left>mdi-content-save</v-icon>
              บันทึก
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <!-- Cut Transfer Dialog -->
      <v-dialog v-model="positionMoveCutdialog" persistent max-width="800px">
        <v-card class="rounded-lg">
          <v-toolbar color="primary" dark flat>
            <v-icon left>mdi-content-cut</v-icon>
            <v-toolbar-title>ตัดโอนตำแหน่ง</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn icon @click="positionMoveCutdialog = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-toolbar>
          <v-card-text class="pa-4">
            <v-alert type="info" text dense border="left" class="mb-4">
              การตัดโอนจะโอนตำแหน่งและเลขที่ไปสังกัดใหม่
            </v-alert>

            <div class="mb-3">
              <div class="subtitle-2 grey--text text--darken-2">
                ข้อมูลผู้ขอย้าย
              </div>
              <div class="text-h6">
                {{ transference_personnels_id_ref.personnel_name }}
              </div>
              <div class="caption">
                ตำแหน่งที่จะตัดโอน:
                {{ transference_personnels_id_ref.id_position }}
              </div>
            </div>

            <v-divider class="my-3"></v-divider>

            <v-autocomplete
              :items="colleges"
              item-text="college_name"
              item-value="college_code"
              v-model="updatepositions.ctscollege_code"
              label="วิทยาลัยปลายทาง"
              outlined
              dense
              prepend-inner-icon="mdi-school"
            ></v-autocomplete>
          </v-card-text>
          <v-card-actions class="justify-end pa-4">
            <v-btn text @click="positionMoveCutdialog = false">
              <v-icon left>mdi-close</v-icon>
              ยกเลิก
            </v-btn>
            <v-btn
              color="primary"
              dark
              depressed
              @click="updatepositionMoveCutSubmit"
              :disabled="!updatepositions.ctscollege_code"
            >
              <v-icon left>mdi-content-save</v-icon>
              บันทึก
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <!-- Cancel Transfer Dialog -->
      <v-dialog v-model="canceldialog" persistent max-width="500px">
        <v-card class="rounded-lg">
          <v-card-title class="headline warning--text">
            <v-icon left color="warning">mdi-alert</v-icon>
            ยืนยันการยกเลิก
          </v-card-title>
          <v-card-text class="pt-4">
            <v-alert type="warning" text border="left" class="mb-3">
              คุณต้องการยกเลิกรายการย้ายของ
              <strong>{{
                transference_personnels_id_ref.personnel_name
              }}</strong>
              ใช่หรือไม่?
            </v-alert>
          </v-card-text>
          <v-card-actions class="justify-end pa-4">
            <v-btn text @click="canceldialog = false">
              <v-icon left>mdi-close</v-icon>
              ปิด
            </v-btn>
            <v-btn color="warning" depressed @click="cancelSubmit">
              <v-icon left>mdi-check</v-icon>
              ยืนยัน
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <!-- Director Comment Dialog -->
      <v-dialog v-model="commentDrdialog" persistent max-width="700px">
        <v-card class="rounded-lg">
          <v-toolbar color="warning darken-2" dark flat dense>
            <v-icon left>mdi-comment-account</v-icon>
            <v-toolbar-title>ความเห็น ผอ.วิทยาลัย</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn icon @click="commentDrdialog = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-toolbar>
          <v-card-text class="pt-4">
            <div class="mb-3">
              <div class="subtitle-2 grey--text text--darken-2">ผู้ขอย้าย</div>
              <div class="text-h6">
                {{ transference_personnels_id_ref.personnel_name }}
              </div>
            </div>

            <v-divider class="my-3"></v-divider>

            <div class="subtitle-2 mb-2">ความเห็น</div>
            <v-radio-group
              v-model="transference_personnels_id_ref.comment_dr_c"
              row
              class="justify-center mt-0"
            >
              <v-radio label="เห็นควร" value="approp" color="success">
                <template v-slot:label>
                  <div class="d-flex align-center">
                    <v-icon left color="success">mdi-check-circle</v-icon>
                    <span>เห็นควร</span>
                  </div>
                </template>
              </v-radio>
              <v-radio label="ไม่เห็นควร" value="inapprop" color="warning">
                <template v-slot:label>
                  <div class="d-flex align-center">
                    <v-icon left color="warning">mdi-alert-circle</v-icon>
                    <span>ไม่เห็นควร</span>
                  </div>
                </template>
              </v-radio>
              <v-radio label="ระงับย้าย" value="suspend" color="error">
                <template v-slot:label>
                  <div class="d-flex align-center">
                    <v-icon left color="error">mdi-cancel</v-icon>
                    <span>ระงับย้าย</span>
                  </div>
                </template>
              </v-radio>
            </v-radio-group>

            <v-textarea
              v-if="transference_personnels_id_ref.comment_dr_c !== 'approp'"
              label="เหตุผล"
              v-model="transference_personnels_id_ref.detail_comment"
              outlined
              dense
              rows="3"
            ></v-textarea>

            <v-divider class="my-4"></v-divider>

            <div class="subtitle-2 mb-2">สถานะเอกสาร</div>
            <v-radio-group
              v-model="transference_personnels_id_ref.status_document"
              row
              dense
              class="mt-0"
            >
              <v-radio label="สมบูรณ์" value="complete" color="success">
                <template v-slot:label>
                  <div class="d-flex align-center">
                    <v-icon left color="success" small>mdi-file-check</v-icon>
                    <span>สมบูรณ์</span>
                  </div>
                </template>
              </v-radio>
              <v-radio label="ไม่สมบูรณ์" value="incomplete" color="warning">
                <template v-slot:label>
                  <div class="d-flex align-center">
                    <v-icon left color="warning" small>mdi-file-alert</v-icon>
                    <span>ไม่สมบูรณ์</span>
                  </div>
                </template>
              </v-radio>
              <v-radio label="ไม่ส่ง" value="do_not" color="error">
                <template v-slot:label>
                  <div class="d-flex align-center">
                    <v-icon left color="error" small>mdi-file-remove</v-icon>
                    <span>ไม่ส่ง</span>
                  </div>
                </template>
              </v-radio>
            </v-radio-group>
          </v-card-text>
          <v-card-actions class="justify-end pa-4">
            <v-btn text @click="commentDrdialog = false">
              <v-icon left>mdi-close</v-icon>
              ยกเลิก
            </v-btn>
            <v-btn
              color="warning darken-2"
              dark
              depressed
              @click="updatecommentSubmit"
              :disabled="
                !transference_personnels_id_ref.comment_dr_c ||
                  !transference_personnels_id_ref.status_document
              "
            >
              <v-icon left>mdi-content-save</v-icon>
              บันทึก
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <!-- Provincial Committee Comment Dialog -->
      <v-dialog v-model="comment_stb_Drdialog" persistent max-width="700px">
        <v-card class="rounded-lg">
          <v-toolbar color="info darken-1" dark flat dense>
            <v-icon left>mdi-account-group</v-icon>
            <v-toolbar-title>ความเห็น สอจ./อ.ก.ค.ศ.</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn icon @click="comment_stb_Drdialog = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-toolbar>
          <v-card-text class="pt-4">
            <div class="mb-3">
              <div class="subtitle-2 grey--text text--darken-2">ผู้ขอย้าย</div>
              <div class="text-h6">
                {{ transference_personnels_id_ref.personnel_name }}
              </div>
            </div>

            <v-divider class="my-3"></v-divider>

            <div class="subtitle-2 mb-2">ความเห็นคณะกรรมการ</div>
            <v-radio-group
              v-model="transference_personnels_id_ref.tp_comment_dr_stb"
              row
              class="justify-center mt-0"
            >
              <v-radio label="เห็นควร" value="approp" color="success">
                <template v-slot:label>
                  <div class="d-flex align-center">
                    <v-icon left color="success">mdi-check-decagram</v-icon>
                    <span>เห็นควร</span>
                  </div>
                </template>
              </v-radio>
              <v-radio label="ไม่เห็นควร" value="inapprop" color="warning">
                <template v-slot:label>
                  <div class="d-flex align-center">
                    <v-icon left color="warning">mdi-alert-decagram</v-icon>
                    <span>ไม่เห็นควร</span>
                  </div>
                </template>
              </v-radio>
              <v-radio label="ระงับ" value="suspend" color="error">
                <template v-slot:label>
                  <div class="d-flex align-center">
                    <v-icon left color="error">mdi-cancel</v-icon>
                    <span>ระงับ</span>
                  </div>
                </template>
              </v-radio>
            </v-radio-group>
          </v-card-text>
          <v-card-actions class="justify-end pa-4">
            <v-btn text @click="comment_stb_Drdialog = false">
              <v-icon left>mdi-close</v-icon>
              ยกเลิก
            </v-btn>
            <v-btn
              color="info darken-1"
              dark
              depressed
              @click="updateCommentStbSubmit"
              :disabled="!transference_personnels_id_ref.tp_comment_dr_stb"
            >
              <v-icon left>mdi-content-save</v-icon>
              บันทึก
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <!-- File Upload Dialog -->
      <v-dialog v-model="updateFileDocdialog" persistent max-width="600px">
        <v-card class="rounded-lg">
          <v-toolbar color="info" dark flat dense>
            <v-icon left>mdi-file-upload</v-icon>
            <v-toolbar-title>แนบไฟล์เอกสาร</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn icon @click="updateFileDocdialog = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-toolbar>
          <v-card-text class="pt-4">
            <v-alert type="info" text dense border="left" class="mb-3">
              <div class="caption">รองรับไฟล์ PDF | ไม่เกิน 10 MB</div>
            </v-alert>

            <v-file-input
              v-model="documentsLinkfiles"
              label="แบบคำร้องขอย้าย (.pdf)"
              accept=".pdf"
              outlined
              dense
              prepend-icon="mdi-file-pdf-box"
              :rules="fileRules"
              show-size
            >
              <template v-slot:selection="{ text }">
                <v-chip small color="primary" text-color="white">
                  <v-icon left small>mdi-file-pdf-box</v-icon>
                  {{ text }}
                </v-chip>
              </template>
            </v-file-input>

            <v-file-input
              v-model="documentsLinkfiles3"
              label="เอกสารตัวชี้วัด 1.4 (.pdf)"
              accept=".pdf"
              outlined
              dense
              prepend-icon="mdi-file-chart"
              :rules="fileRules"
              show-size
            >
              <template v-slot:selection="{ text }">
                <v-chip small color="info" text-color="white">
                  <v-icon left small>mdi-file-chart</v-icon>
                  {{ text }}
                </v-chip>
              </template>
            </v-file-input>
          </v-card-text>
          <v-card-actions class="justify-end pa-4">
            <v-btn text @click="updateFileDocdialog = false">
              <v-icon left>mdi-close</v-icon>
              ยกเลิก
            </v-btn>
            <v-btn
              color="info"
              depressed
              @click="updateFileDocSubmit"
              :loading="uploadingFile"
            >
              <v-icon left>mdi-cloud-upload</v-icon>
              อัปโหลด
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <!-- PDF Viewer Dialog -->
      <v-dialog
        v-model="pdfdocumentsLinkfileDialog"
        fullscreen
        hide-overlay
        transition="dialog-bottom-transition"
      >
        <v-card>
          <v-toolbar dark color="grey darken-3">
            <v-btn icon dark @click="pdfdocumentsLinkfileDialog = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
            <v-toolbar-title>ตัวอย่างเอกสาร</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn icon dark :href="`/HRvecfiles/${pdf_files}`" download>
              <v-icon>mdi-download</v-icon>
            </v-btn>
          </v-toolbar>
          <div style="height: 100vh; background: #525659;">
            <embed
              :src="`/HRvecfiles/${pdf_files}#toolbar=1`"
              width="100%"
              height="100%"
              type="application/pdf"
            />
          </div>
        </v-card>
      </v-dialog>

      <!-- Password Dialog (Fixed) -->
      <v-dialog v-model="passwordDialog" persistent max-width="450px">
        <v-card class="rounded-lg">
          <v-card-title class="headline error--text">
            <v-icon left color="error">mdi-lock-alert</v-icon>
            ยืนยันตัวตนด้วยรหัสผ่าน
          </v-card-title>
          <v-card-text class="pt-4">
            <v-alert type="error" text border="left" class="mb-3">
              <div class="font-weight-bold">
                การดำเนินการนี้ต้องการรหัสยืนยัน!
              </div>
              <div class="caption">
                กรุณาระบุรหัสผ่านเพื่อยืนยันการ{{ currentDeleteAction }}
              </div>
            </v-alert>

            <v-text-field
              v-model="passwordInput"
              label="รหัสผ่านยืนยัน"
              :type="showPassword ? 'text' : 'password'"
              outlined
              dense
              prepend-inner-icon="mdi-lock"
              :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
              @click:append="showPassword = !showPassword"
              @keyup.enter="verifyPassword"
              :error-messages="passwordError"
              autofocus
            ></v-text-field>
          </v-card-text>
          <v-card-actions class="justify-end pa-4">
            <v-btn text @click="cancelPasswordVerification">
              <v-icon left>mdi-close</v-icon>
              ยกเลิก
            </v-btn>
            <v-btn
              color="error"
              depressed
              @click="verifyPassword"
              :disabled="!passwordInput"
            >
              <v-icon left>mdi-check</v-icon>
              ยืนยัน
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <!-- Snackbar -->
      <v-snackbar
        v-model="snackbar.show"
        :color="snackbar.color"
        top
        right
        rounded="pill"
        :timeout="3000"
      >
        <v-icon left color="white">{{ snackbar.icon }}</v-icon>
        {{ snackbar.text }}
        <template v-slot:action="{ attrs }">
          <v-btn text v-bind="attrs" @click="snackbar.show = false" icon>
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </template>
      </v-snackbar>
    </v-container>
  </div>
</template>
<script>
import Movementmenu from "../../components/admin/movementmenu.vue";
import * as XLSX from "xlsx";

export default {
  name: "TransferencePersonnelManagement",
  components: { Movementmenu },

  data() {
    return {
      // API Configuration
      ApiKey: "HRvec2021",
      ADMIN_PASSWORD: "0612698358",

      // Loading States
      loading: false,
      loadingPositions: false,
      uploadingFile: false,

      // Search & Filter
      search: "",

      // Dialog Controls
      positiondialog: false,
      positionMoveCutdialog: false,
      canceldialog: false,
      commentDrdialog: false,
      updateFileDocdialog: false,
      comment_stb_Drdialog: false,
      pdfdocumentsLinkfileDialog: false,
      passwordDialog: false,

      // Password Verification
      passwordInput: "",
      passwordError: "",
      showPassword: false,
      currentDeleteAction: "",
      pendingDeleteCallback: null,

      // Data Collections
      transference_personnels: [],
      transference_personnelCount: {
        sumAll: 0,
        sumcc: 0,
        sumpvccc: 0,
        sumsuc: 0,
        sumdoc: 0,
        sumdocpvcfile: 0,
        conditions: 0,
        localDevs: 0,
        sounths: 0
      },
      transference_personnels_id_ref: {},
      conditons_transfer_successs: {},
      man_powers: [],
      colleges: [],
      periods: {},

      // Form Inputs
      updatepositions: {
        ctscollege_code: null,
        ctsid_position: null
      },
      documentsLinkfiles: null,
      documentsLinkfiles3: null,
      pdf_files: null,

      // UI Configuration
      snackbar: {
        show: false,
        color: "info",
        icon: "mdi-information",
        text: ""
      },

      // Table Headers
      selectedHeaders: [],
      headersMap: [
        {
          text: "ย้ายปกติ",
          value: "actions",
          align: "center",
          sortable: false,
          width: "100px"
        },
        {
          text: "ตัดโอน",
          value: "MoveCut",
          align: "center",
          sortable: false,
          width: "100px"
        },
        {
          text: "สถานะปลายทาง",
          value: "succ_college",
          align: "center",
          width: "120px"
        },
        {
          text: "วิทยาลัยปลายทาง",
          value: "college_name_suss",
          align: "left",
          width: "200px"
        },
        {
          text: "เลขที่ใหม่",
          value: "id_position_new",
          align: "center",
          width: "120px"
        },
        {
          text: "รหัสบัตรประชาชน",
          value: "id_card",
          align: "left",
          width: "150px"
        },
        {
          text: "ผู้ขอย้าย",
          value: "personnel_name",
          align: "left",
          width: "200px"
        },
        {
          text: "สถานะบันทึก",
          value: "transfer_status",
          align: "center",
          width: "140px"
        },
        {
          text: "สังกัดปัจจุบัน",
          value: "college_name",
          align: "left",
          width: "200px"
        },
        {
          text: "ไฟล์แนบ",
          value: "updateFileDoc",
          align: "center",
          width: "100px"
        },
        {
          text: "ความเห็น ผอ.วิทฯ",
          value: "comment_dr_c",
          align: "center",
          width: "120px"
        },
        {
          text: "ความเห็น ผอ.สถาบันฯ",
          value: "tp_comment_dr_stb",
          align: "center",
          width: "120px"
        },
        {
          text: "เอกสารคำร้อง",
          value: "documentsLinkfile",
          align: "center",
          width: "120px"
        },
        {
          text: "ไฟล์คะแนน สอจ.",
          value: "tpvecprovince_scoreFile",
          align: "center",
          width: "120px"
        },

        {
          text: "คะแนน สอจ.",
          value: "tpvecprovince_score",
          align: "center",
          width: "120px"
        },

        {
          text: "คะแนน กก.",
          value: "score_1420",
          align: "center",
          width: "100px"
        },
        {
          text: "รับเรื่อง",
          value: "actionReceipt",
          align: "center",
          width: "100px"
        },
        {
          text: "ลบ",
          value: "del",
          align: "center",
          sortable: false,
          width: "80px"
        }
      ],
      headers: [],

      // File Validation Rules
      fileRules: [
        value => !value || value.size < 10485760 || "ขนาดไฟล์ต้องไม่เกิน 10 MB",
        value =>
          !value || value.type === "application/pdf" || "รองรับเฉพาะไฟล์ PDF"
      ]
    };
  },

  computed: {
    showHeaders() {
      return this.selectedHeaders;
    },
    time_stamp() {
      return Date.now();
    }
  },

  async created() {
    this.headers = this.headersMap;
    this.selectedHeaders = this.headers;
  },

  async mounted() {
    await this.fetchInitialData();
  },

  methods: {
    // ===== INITIALIZATION =====
    async fetchInitialData() {
      this.loading = true;
      try {
        // โหลดข้อมูลงวด
        let resPeriod = await this.$http.post("period.php", {
          ApiKey: this.ApiKey,
          period_enable_process: "1",
          period_id: "301"
        });
        this.periods = resPeriod.data;

        // โหลดวิทยาลัย
        let resCol = await this.$http.post("college.php", {
          ApiKey: this.ApiKey
        });
        this.colleges = resCol.data;

        // โหลดข้อมูลบุคลากร
        await this.transference_personnelQueryAll();
      } catch (error) {
        console.error("Error fetching initial data:", error);
        this.showSnackbar("เกิดข้อผิดพลาดในการโหลดข้อมูล", "error");
      } finally {
        this.loading = false;
      }
    },

    // ===== DATA QUERIES =====
    async transference_personnelQueryAll() {
      this.loading = true;
      try {
        let res = await this.$http.post("transference_personnel.php", {
          ApiKey: this.ApiKey,
          time_s: this.periods.period_times,
          year_s: this.periods.period_year,
          type_move: "nm"
        });

        this.transference_personnels = res.data || [];
        this.calculateStats();
      } catch (error) {
        console.error("Error querying personnel:", error);
        this.showSnackbar("เกิดข้อผิดพลาดในการดึงข้อมูล", "error");
      } finally {
        this.loading = false;
      }
    },

    calculateStats() {
      let data = this.transference_personnels;
      this.transference_personnelCount = {
        sumAll: data.length,
        sumcc: data.filter(x => x.ccDocumentFile === "cc").length,
        sumpvccc: data.filter(x => x.ccDocumentFilePVC === "cc").length,
        sumsuc: data.filter(x => x.transfer_status === "save").length,
        sumdoc: data.filter(x => String(x.documentsLinkfile || "").length > 6)
          .length,
        sumdocpvcfile: data.filter(x => x.tpvecprovince_scoreFile).length,
        conditions: data.filter(x => x.type_personnel === "select").length,
        localDevs: data.filter(x => x.type_personnel === "local_dev").length,
        sounths: data.filter(
          x => x.province_difficulty == 1 || x.prefecture_difficulty == 1
        ).length
      };
    },

    async showSuccessPosition() {
      this.loading = true;
      try {
        let res = await this.$http.post("transference_personnel.php", {
          ApiKey: this.ApiKey,
          time_s: this.periods.period_times,
          year_s: this.periods.period_year,
          type_move: "nm",
          success_s: "ok"
        });
        this.transference_personnels = res.data || [];
        this.calculateStats();
        this.showSnackbar("แสดงรายการที่สำเร็จแล้ว", "success");
      } catch (error) {
        this.showSnackbar("เกิดข้อผิดพลาด", "error");
      } finally {
        this.loading = false;
      }
    },

    async Searchtemporary() {
      this.loading = true;
      try {
        let res = await this.$http.post("transference_personnel.php", {
          ApiKey: this.ApiKey,
          time_s: this.periods.period_times,
          year_s: this.periods.period_year,
          transfer_status: "temporary"
        });
        this.transference_personnels = res.data || [];
        this.calculateStats();
        this.showSnackbar("แสดงรายการที่ยังไม่บันทึก", "info");
      } catch (error) {
        this.showSnackbar("เกิดข้อผิดพลาด", "error");
      } finally {
        this.loading = false;
      }
    },

    async SearchCCdoc() {
      this.loading = true;
      try {
        let res = await this.$http.post("transference_personnel.php", {
          ApiKey: this.ApiKey,
          time_s: this.periods.period_times,
          year_s: this.periods.period_year,
          type_move: "nm",
          ccDocumentFile: "cc"
        });
        this.transference_personnels = res.data || [];
        this.calculateStats();
        this.showSnackbar(
          `พบรายการแจ้งยกเลิก ${this.transference_personnels.length} รายการ`,
          "warning"
        );
      } catch (error) {
        this.showSnackbar("เกิดข้อผิดพลาด", "error");
      } finally {
        this.loading = false;
      }
    },

    async SearchPVCCCdoc() {
      this.loading = true;
      try {
        let res = await this.$http.post("transference_personnel.php", {
          ApiKey: this.ApiKey,
          time_s: this.periods.period_times,
          year_s: this.periods.period_year,
          type_move: "nm",
          ccDocumentFilePVC: "cc"
        });
        this.transference_personnels = res.data || [];
        this.calculateStats();
        this.showSnackbar(
          `พบรายการแจ้งยกเลิก ${this.transference_personnels.length} รายการ`,
          "warning"
        );
      } catch (error) {
        this.showSnackbar("เกิดข้อผิดพลาด", "error");
      } finally {
        this.loading = false;
      }
    },

    async fetchPersonDetail(tid_ref) {
      try {
        let res = await this.$http.post("transference_personnel.php", {
          ApiKey: this.ApiKey,
          id_ref: tid_ref
        });
        this.transference_personnels_id_ref = res.data || {};
      } catch (error) {
        console.error("Error fetching person detail:", error);
        this.showSnackbar("ไม่สามารถโหลดข้อมูลบุคคลได้", "error");
      }
    },

    // ===== TRANSFER POSITION MANAGEMENT =====
    async select_idPosition(tid_ref) {
      await this.fetchPersonDetail(tid_ref);
      this.updatepositions = {
        ctscollege_code: null,
        ctsid_position: null
      };
      this.man_powers = [];
      this.positiondialog = true;
    },

    async select_idPositionMoveCut(tid_ref) {
      await this.fetchPersonDetail(tid_ref);
      this.updatepositions = {
        ctscollege_code: null,
        ctsid_position: null
      };
      this.positionMoveCutdialog = true;
    },

    async man_powerQuery() {
      if (!this.updatepositions.ctscollege_code) return;

      this.loadingPositions = true;
      try {
        let res = await this.$http.post("man_power_process.php", {
          ApiKey: this.ApiKey,
          college_code: this.updatepositions.ctscollege_code
        });
        this.man_powers = res.data || [];

        if (this.man_powers.length === 0) {
          this.showSnackbar("ไม่พบตำแหน่งว่างในวิทยาลัยนี้", "warning");
        }
      } catch (error) {
        this.showSnackbar("เกิดข้อผิดพลาดในการค้นหาตำแหน่ง", "error");
      } finally {
        this.loadingPositions = false;
      }
    },

    async updatepositionSubmit() {
      const person = this.transference_personnels_id_ref;
      const form = this.updatepositions;

      if (!form.ctscollege_code || !form.ctsid_position) {
        this.showSnackbar("กรุณาเลือกวิทยาลัยและตำแหน่ง", "warning");
        return;
      }

      this.loading = true;
      try {
        // 1. Payload สำหรับบันทึกการจัดสรร
        let payload = {
          ApiKey: this.ApiKey,
          ctsid_ref: person.tid_ref,
          ctstime_s: person.time_ss,
          ctsyear_s: person.year_ss,
          ctsid_postion_old: person.id_position,
          ctscollege_code_old: person.college_code,
          ctsid_card: person.id_card,
          ctsname_position: "ครู",
          ctsstatus_select: "demand",
          ctsid_position: form.ctsid_position,
          ctscollege_code: form.ctscollege_code
        };

        // 2. Payload สำหรับคืนตำแหน่งเก่า
        let returnPayload = {
          ApiKey: this.ApiKey,
          college_code: person.college_code,
          id_position: person.id_position,
          position: "ครู",
          case_vacancy: `ย้ายรอบ-${person.time_ss}/${person.year_ss}`
        };

        // 3. ดำเนินการทั้ง 3 ขั้นตอน
        let [res1, res2, res3] = await Promise.all([
          this.$http.post("man_power.insert.php", returnPayload),
          this.$http.post("man_power.update_process.php", {
            ApiKey: this.ApiKey,
            id_position: form.ctsid_position,
            status_booking: person.id_card
          }),
          this.$http.post("conditons_transfer_success.insert.php", payload)
        ]);

        if (res1.data.status && res2.data.status && res3.data.status) {
          this.showSnackbar("บันทึกการจัดสรรเรียบร้อย", "success");
          this.positiondialog = false;
          await this.transference_personnelQueryAll();
        } else {
          throw new Error("บางขั้นตอนล้มเหลว");
        }
      } catch (error) {
        console.error("Error in updatepositionSubmit:", error);
        this.showSnackbar("เกิดข้อผิดพลาดในการบันทึก", "error");
      } finally {
        this.loading = false;
      }
    },

    async updatepositionMoveCutSubmit() {
      const person = this.transference_personnels_id_ref;
      const form = this.updatepositions;

      if (!form.ctscollege_code) {
        this.showSnackbar("กรุณาเลือกวิทยาลัยปลายทาง", "warning");
        return;
      }

      this.loading = true;
      try {
        let payload = {
          ApiKey: this.ApiKey,
          ctsid_ref: person.tid_ref,
          ctstime_s: person.time_ss,
          ctsyear_s: person.year_ss,
          ctscollege_code_old: person.college_code,
          ctsid_postion_old: person.id_position,
          ctsid_position: person.id_position,
          ctsid_card: person.id_card,
          ctsname_position: "ครู",
          ctsstatus_select: "transfer",
          ctscollege_code: form.ctscollege_code
        };

        let res = await this.$http.post(
          "conditons_transfer_success.insert.php",
          payload
        );

        if (res.data.status) {
          this.showSnackbar("บันทึกการตัดโอนเรียบร้อย", "success");
          this.positionMoveCutdialog = false;
          await this.transference_personnelQueryAll();
        } else {
          throw new Error("การบันทึกล้มเหลว");
        }
      } catch (error) {
        console.error("Error in updatepositionMoveCutSubmit:", error);
        this.showSnackbar("เกิดข้อผิดพลาด", "error");
      } finally {
        this.loading = false;
      }
    },

    async deletePosition(tid_ref) {
      await this.fetchPersonDetail(tid_ref);

      try {
        let resCts = await this.$http.post("conditons_transfer_success.php", {
          ApiKey: this.ApiKey,
          ctsid_ref: tid_ref
        });
        this.conditons_transfer_successs = resCts.data || {};
        this.canceldialog = true;
      } catch (error) {
        this.showSnackbar("ไม่สามารถโหลดข้อมูลการย้ายได้", "error");
      }
    },

    async cancelSubmit() {
      const ctsData = this.conditons_transfer_successs;

      if (!ctsData || !ctsData.id_cts) {
        this.showSnackbar("ไม่พบข้อมูลการย้าย", "error");
        return;
      }

      this.loading = true;
      try {
        // 1. ปลดล็อคตำแหน่งใหม่
        await this.$http.post("man_power.update_process.php", {
          ApiKey: this.ApiKey,
          status_booking: "",
          id_position: ctsData.ctsid_position
        });

        // 2. ลบตำแหน่งที่คืนกลับ
        if (ctsData.ctsid_postion_old) {
          await this.$http.post("man_power.delete.php", {
            ApiKey: this.ApiKey,
            id_position: ctsData.ctsid_postion_old
          });
        }

        // 3. ลบบันทึกการย้าย
        let res = await this.$http.post(
          "conditons_transfer_success.delete.php",
          {
            ApiKey: this.ApiKey,
            id_cts: ctsData.id_cts
          }
        );

        if (res.data.status) {
          this.showSnackbar("ยกเลิกรายการเรียบร้อย", "success");
          this.canceldialog = false;
          await this.transference_personnelQueryAll();
        } else {
          throw new Error("การยกเลิกล้มเหลว");
        }
      } catch (error) {
        console.error("Error in cancelSubmit:", error);
        this.showSnackbar("เกิดข้อผิดพลาด", "error");
      } finally {
        this.loading = false;
      }
    },

    // ===== COMMENT & STATUS MANAGEMENT =====
    async comment_idPosition(tid_ref) {
      await this.fetchPersonDetail(tid_ref);
      this.commentDrdialog = true;
    },

    async updatecommentSubmit() {
      const person = this.transference_personnels_id_ref;

      if (!person.comment_dr_c || !person.status_document) {
        this.showSnackbar("กรุณาระบุข้อมูลให้ครบถ้วน", "warning");
        return;
      }

      if (person.comment_dr_c !== "approp" && !person.detail_comment) {
        this.showSnackbar("กรุณาระบุเหตุผล", "warning");
        return;
      }

      this.loading = true;
      try {
        let payload = {
          ApiKey: this.ApiKey,
          id_tfp: person.id_tfp,
          comment_dr_c: person.comment_dr_c,
          detail_comment: person.detail_comment || "",
          status_document: person.status_document
        };

        let res = await this.$http.post(
          "transference_personnel.update.php",
          payload
        );

        if (res.data.status) {
          this.showSnackbar("บันทึกความเห็นเรียบร้อย", "success");
          this.commentDrdialog = false;
          await this.transference_personnelQueryAll();
        } else {
          throw new Error("การบันทึกล้มเหลว");
        }
      } catch (error) {
        this.showSnackbar("เกิดข้อผิดพลาด", "error");
      } finally {
        this.loading = false;
      }
    },

    async tp_comment_dr_stbPosition(tid_ref) {
      await this.fetchPersonDetail(tid_ref);
      this.comment_stb_Drdialog = true;
    },

    async updateCommentStbSubmit() {
      const person = this.transference_personnels_id_ref;

      if (!person.tp_comment_dr_stb) {
        this.showSnackbar("กรุณาเลือกความเห็น", "warning");
        return;
      }

      this.loading = true;
      try {
        let payload = {
          ApiKey: this.ApiKey,
          id_tfp: person.id_tfp,
          tp_comment_dr_stb: person.tp_comment_dr_stb
        };

        let res = await this.$http.post(
          "transference_personnel.update.php",
          payload
        );

        if (res.data.status) {
          this.showSnackbar("บันทึกความเห็น สอจ. เรียบร้อย", "success");
          this.comment_stb_Drdialog = false;
          await this.transference_personnelQueryAll();
        } else {
          throw new Error("การบันทึกล้มเหลว");
        }
      } catch (error) {
        this.showSnackbar("เกิดข้อผิดพลาด", "error");
      } finally {
        this.loading = false;
      }
    },

    async changeStatus(tid_ref) {
      try {
        await this.$http.post("transference_personnel.update.php", {
          ApiKey: this.ApiKey,
          id_ref: tid_ref,
          transfer_status: "save"
        });
        this.showSnackbar("เปลี่ยนสถานะเป็น 'บันทึกแล้ว'", "success");
        await this.transference_personnelQueryAll();
      } catch (error) {
        this.showSnackbar("เกิดข้อผิดพลาด", "error");
      }
    },

    // ===== FILE MANAGEMENT =====
    async updateFileDoc(tid_ref) {
      await this.fetchPersonDetail(tid_ref);
      this.documentsLinkfiles = null;
      this.documentsLinkfiles3 = null;
      this.updateFileDocdialog = true;
    },

    async updateFileDocSubmit() {
      if (!this.documentsLinkfiles && !this.documentsLinkfiles3) {
        this.showSnackbar("กรุณาเลือกไฟล์อย่างน้อย 1 รายการ", "warning");
        return;
      }

      this.uploadingFile = true;
      try {
        let person = this.transference_personnels_id_ref;
        let updatePayload = {
          ApiKey: this.ApiKey,
          id_tfp: person.id_tfp,
          id_ref: person.tid_ref
        };

        // 1. อัปโหลดเอกสารคำร้อง
        if (this.documentsLinkfiles) {
          let formData = new FormData();
          let filename = `${person.tid_ref}_${Date.now()}_doc.pdf`;
          formData.append("ApiKey", this.ApiKey);
          formData.append("file", this.documentsLinkfiles);
          formData.append("filename", "../HRvecfiles/" + filename);

          let res = await this.$http.post("uploadfile.php", formData, {
            headers: { "Content-Type": "multipart/form-data" }
          });

          if (res.data.status) {
            updatePayload.documentsLinkfile = filename;
          } else {
            throw new Error("การอัปโหลดเอกสารคำร้องล้มเหลว");
          }
        }

        // 2. อัปโหลดเอกสารคะแนน
        if (this.documentsLinkfiles3) {
          let formData = new FormData();
          let filename = `${person.tid_ref}_${Date.now()}_score.pdf`;
          formData.append("ApiKey", this.ApiKey);
          formData.append("file", this.documentsLinkfiles3);
          formData.append("filename", "../HRvecfiles/" + filename);

          let res = await this.$http.post("uploadfile.php", formData, {
            headers: { "Content-Type": "multipart/form-data" }
          });

          if (res.data.status) {
            updatePayload.doccon_14 = filename;
          } else {
            throw new Error("การอัปโหลดเอกสารคะแนนล้มเหลว");
          }
        }

        // 3. บันทึกลงฐานข้อมูล
        let resUpdate = await this.$http.post(
          "transference_personnel.update.php",
          updatePayload
        );

        if (resUpdate.data.status) {
          this.showSnackbar("อัปโหลดไฟล์เรียบร้อย", "success");
          this.updateFileDocdialog = false;
          await this.transference_personnelQueryAll();
        } else {
          throw new Error("บันทึกข้อมูลล้มเหลว");
        }
      } catch (error) {
        console.error("Error uploading files:", error);
        this.showSnackbar(error.message || "เกิดข้อผิดพลาด", "error");
      } finally {
        this.uploadingFile = false;
      }
    },

    viewdocumentsLinkfile(file) {
      this.pdf_files = file;
      this.pdfdocumentsLinkfileDialog = true;
    },

    // ===== DELETE OPERATIONS WITH PASSWORD =====
    async CancelFilePDF(tid_ref) {
      this.currentDeleteAction = "ลบไฟล์เอกสาร";
      this.pendingDeleteCallback = async () => {
        this.loading = true;
        try {
          let res = await this.$http.post("transference_personnel.php", {
            ApiKey: this.ApiKey,
            id_ref: tid_ref
          });
          let currentData = res.data;

          // ลบไฟล์
          if (currentData.documentsLinkfile) {
            await this.$http.post("deletefile.php", {
              ApiKey: this.ApiKey,
              filename: "../HRvecfiles/" + currentData.documentsLinkfile
            });
          }

          // อัปเดตฐานข้อมูล
          let updateRes = await this.$http.post(
            "transference_personnel.update.php",
            {
              ApiKey: this.ApiKey,
              id_tfp: currentData.id_tfp,
              documentsLinkfile: "",
              ccDocumentFile: ""
            }
          );

          if (updateRes.data.status) {
            this.showSnackbar("ลบไฟล์เรียบร้อย", "success");
            await this.transference_personnelQueryAll();
          } else {
            throw new Error("การอัปเดตล้มเหลว");
          }
        } catch (error) {
          console.error("Error deleting file:", error);
          this.showSnackbar("เกิดข้อผิดพลาด", "error");
        } finally {
          this.loading = false;
        }
      };
      this.passwordDialog = true;
    },

    async CancelFilePDFProvince(tid_ref) {
      this.currentDeleteAction = "ลบไฟล์คะแนน สอจ.";
      this.pendingDeleteCallback = async () => {
        this.loading = true;
        try {
          let res = await this.$http.post("transference_personnel.php", {
            ApiKey: this.ApiKey,
            id_ref: tid_ref
          });
          let currentData = res.data;

          // ลบไฟล์
          if (currentData.tpvecprovince_scoreFile) {
            await this.$http.post("deletefile.php", {
              ApiKey: this.ApiKey,
              filename: "../HRvecfiles/" + currentData.tpvecprovince_scoreFile
            });
          }

          // อัปเดตฐานข้อมูล
          let updateRes = await this.$http.post(
            "transference_personnel.update.php",
            {
              ApiKey: this.ApiKey,
              id_tfp: currentData.id_tfp,
              tpvecprovince_scoreFile: "",
              ccDocumentFilePVC: ""
            }
          );

          if (updateRes.data.status) {
            this.showSnackbar("ลบไฟล์คะแนนเรียบร้อย", "success");
            await this.transference_personnelQueryAll();
          } else {
            throw new Error("การอัปเดตล้มเหลว");
          }
        } catch (error) {
          console.error("Error deleting score file:", error);
          this.showSnackbar("เกิดข้อผิดพลาด", "error");
        } finally {
          this.loading = false;
        }
      };
      this.passwordDialog = true;
    },

    async deletetpteach(tid_ref) {
      this.currentDeleteAction = "ลบรายการผู้ขอย้าย";
      this.pendingDeleteCallback = async () => {
        this.loading = true;
        try {
          let data = {
            ApiKey: this.ApiKey,
            id_ref: tid_ref
          }
          let res = await this.$http.post("transference_personnel.delupdate.php", data);   

          if (res.data.status) {
            this.showSnackbar("ลบข้อมูลเรียบร้อย", "success");
            await this.transference_personnelQueryAll();
          } else {
            throw new Error("ไม่สามารถลบได้");
          }
        } catch (error) {
          console.error("Error deleting record:", error);
          this.showSnackbar(error.message || "เกิดข้อผิดพลาด", "error");
        } finally {
          this.loading = false;
        }
      };
      this.passwordDialog = true;
    },

    async clearRecordDontSave() {
      this.currentDeleteAction = "ลบรายการขยะทั้งหมด";
      this.pendingDeleteCallback = async () => {
        this.loading = true;
        try {
          let res = await this.$http.post(
            "transference_location.delete.admin.php",
            {
              ApiKey: this.ApiKey
            }
          );

          if (res.data.status) {
            this.showSnackbar(`ลบรายการขยะเรียบร้อย`, "success");
            await this.transference_personnelQueryAll();
          } else {
            this.showSnackbar("ไม่พบรายการขยะ", "info");
          }
        } catch (error) {
          console.error("Error clearing records:", error);
          this.showSnackbar("เกิดข้อผิดพลาด", "error");
        } finally {
          this.loading = false;
        }
      };
      this.passwordDialog = true;
    },

    async optimizeData() {
      this.currentDeleteAction = "จัดระเบียบฐานข้อมูล";
      this.pendingDeleteCallback = async () => {
        this.loading = true;
        try {
          let res = await this.$http.post("transference_update_admin.php", {
            ApiKey: this.ApiKey,
            time_s: this.periods.period_times,
            year_s: this.periods.period_year
          });

          if (res.data.status) {
            this.showSnackbar("จัดระเบียบข้อมูลเรียบร้อย", "success");
            await this.transference_personnelQueryAll();
          } else {
            this.showSnackbar("ไม่พบความผิดปกติ", "info");
          }
        } catch (error) {
          console.error("Error optimizing data:", error);
          this.showSnackbar("เกิดข้อผิดพลาด", "error");
        } finally {
          this.loading = false;
        }
      };
      this.passwordDialog = true;
    },

    // ===== PASSWORD VERIFICATION =====
    verifyPassword() {
      this.passwordError = "";

      if (this.passwordInput === this.ADMIN_PASSWORD) {
        this.passwordDialog = false;
        if (this.pendingDeleteCallback) {
          this.pendingDeleteCallback();
          this.pendingDeleteCallback = null;
        }
        this.passwordInput = "";
      } else {
        this.passwordError = "รหัสผ่านไม่ถูกต้อง";
        this.showSnackbar("รหัสผ่านไม่ถูกต้อง", "error");
      }
    },

    cancelPasswordVerification() {
      this.passwordDialog = false;
      this.passwordInput = "";
      this.passwordError = "";
      this.pendingDeleteCallback = null;
      this.showSnackbar("ยกเลิกการดำเนินการ", "info");
    },

    // ===== RECEIPT MANAGEMENT =====
    async actionReceipts(id_tfp) {
      try {
        let res = await this.$http.post("transference_personnel.update.php", {
          ApiKey: this.ApiKey,
          id_tfp: id_tfp,
          tp14receipt: "success"
        });

        if (res.data.status) {
          this.showSnackbar("รับเรื่องเรียบร้อย", "success");
          await this.transference_personnelQueryAll();
        }
      } catch (error) {
        this.showSnackbar("เกิดข้อผิดพลาด", "error");
      }
    },

    async actionReceiptUpdate(id_tfp) {
      try {
        let res = await this.$http.post("transference_personnel.update.php", {
          ApiKey: this.ApiKey,
          id_tfp: id_tfp,
          tp14receipt: ""
        });

        if (res.data.status) {
          this.showSnackbar("ยกเลิกสถานะเรียบร้อย", "success");
          await this.transference_personnelQueryAll();
        }
      } catch (error) {
        this.showSnackbar("เกิดข้อผิดพลาด", "error");
      }
    },

    // ===== SCORE UPDATE =====
    async updateScore1420(id_tfp, score) {
      if (isNaN(score) || score < 0 || score > 100) {
        this.showSnackbar("กรุณาระบุคะแนนระหว่าง 0-100", "warning");
        await this.transference_personnelQueryAll();
        return;
      }

      try {
        let res = await this.$http.post("transference_personnel.update.php", {
          ApiKey: this.ApiKey,
          id_tfp: id_tfp,
          score_1420: parseFloat(score)
        });

        if (!res.data.status) {
          this.showSnackbar("บันทึกคะแนนล้มเหลว", "error");
          await this.transference_personnelQueryAll();
        }
      } catch (error) {
        this.showSnackbar("เชื่อมต่อเซิร์ฟเวอร์ไม่ได้", "error");
      }
    },

    // ===== EXCEL EXPORT =====
    exportToExcel() {
      try {
        const data = this.transference_personnels.map(item => ({
          "ชื่อ-นามสกุล": item.personnel_name || "-",
          เลขบัตรประชาชน: item.id_card || "-",
          สถานศึกษาปัจจุบัน: item.college_name || "-",
          เลขที่ตำแหน่ง: item.id_position || "-",
          จังหวัด: item.province_name || "-",
          สถานะการบันทึก:
            item.transfer_status === "save" ? "บันทึกแล้ว" : "ยังไม่บันทึก",
          ปลายทางที่ได้: item.college_name_suss || "-",
          เลขที่ตำแหน่งใหม่: item.id_position_new || "-",
          "ความเห็น ผอ.": this.getCommentText(item.comment_dr_c),
          "ความเห็น สอจ.": this.getCommentText(item.tp_comment_dr_stb),
          "คะแนน กก.": item.tpvecprovince_score || 0,
          รับเรื่อง: item.tp14receipt === "success" ? "รับแล้ว" : "ยังไม่รับ"
        }));

        const ws = XLSX.utils.json_to_sheet(data);
        const wscols = [
          { wch: 30 },
          { wch: 15 },
          { wch: 35 },
          { wch: 15 },
          { wch: 20 },
          { wch: 15 },
          { wch: 35 },
          { wch: 15 },
          { wch: 12 },
          { wch: 12 },
          { wch: 10 },
          { wch: 10 }
        ];
        ws["!cols"] = wscols;

        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, "Personnel_Transfer");

        const filename = `รายการขอย้าย_${this.periods.period_times}_${this.periods.period_year}_${this.time_stamp}.xlsx`;
        XLSX.writeFile(wb, filename);

        this.showSnackbar("ส่งออกไฟล์ Excel เรียบร้อย", "success");
      } catch (error) {
        console.error("Error exporting to Excel:", error);
        this.showSnackbar("เกิดข้อผิดพลาดในการส่งออก", "error");
      }
    },

    // ===== HELPER FUNCTIONS =====
    showSnackbar(text, color = "info") {
      const iconMap = {
        success: "mdi-check-circle",
        error: "mdi-alert-circle",
        warning: "mdi-alert",
        info: "mdi-information"
      };

      this.snackbar = {
        show: true,
        text,
        color,
        icon: iconMap[color] || "mdi-information"
      };
    },

    getCommentColor(status) {
      const colorMap = {
        approp: "success",
        inapprop: "warning",
        suspend: "error"
      };
      return colorMap[status] || "grey";
    },

    getCommentText(status) {
      const textMap = {
        approp: "เห็นควร",
        inapprop: "ไม่เห็นควร",
        suspend: "ระงับ"
      };
      return textMap[status] || "รอความเห็น";
    }
  }
};
</script>

<style scoped>
/* ===== TABLE STYLES ===== */
.custom-table >>> thead th {
  background-color: #f5f5f5 !important;
  color: #475569 !important;
  font-weight: 600;
  white-space: nowrap;
  font-size: 0.875rem;
}

.custom-table >>> tbody tr:hover {
  background-color: #f5f5f5 !important;
}

.custom-table >>> tbody td {
  font-size: 0.875rem;
  padding: 8px 12px;
}

.custom-table >>> .v-data-table__wrapper {
  border-radius: 8px;
}

/* ===== UTILITY CLASSES ===== */
.shadow-sm {
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1),
    0 2px 4px -1px rgba(0, 0, 0, 0.06) !important;
}

.bg-light-blue {
  background-color: #f5f5f5;
}

.bg-white {
  background-color: white !important;
}

.pointer,
.cursor-pointer {
  cursor: pointer;
}

.rounded-lg {
  border-radius: 12px !important;
}

/* ===== CARD HOVER EFFECTS ===== */
.v-card.cursor-pointer {
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.v-card.cursor-pointer:hover {
  transform: translateY(-4px);
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.15) !important;
}

/* ===== CHIP STYLES ===== */
.v-chip.cursor-pointer {
  transition: all 0.2s ease;
}

.v-chip.cursor-pointer:hover {
  opacity: 0.8;
  transform: scale(1.05);
}

/* ===== DIALOG ANIMATIONS ===== */
.v-dialog {
  box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25) !important;
}

.v-dialog > .v-card {
  overflow: hidden;
}

/* ===== TOOLBAR STYLES ===== */
.v-toolbar {
  border-bottom: 3px solid rgba(255, 255, 255, 0.2) !important;
}

.v-toolbar.primary {
  background: linear-gradient(135deg, #455a64 0%, #455a64 100%) !important;
}

.v-toolbar.warning,
.v-toolbar[color="amber darken-2"] {
  background: linear-gradient(135deg, #A86400 0%, #A86400 100%) !important;
}

.v-toolbar.purple {
  background: linear-gradient(135deg, #b3151b 0%, #b3151b 100%) !important;
}

.v-toolbar[color="teal darken-1"] {
  background: linear-gradient(135deg, #455a64 0%, #263238 100%) !important;
}

.v-toolbar.info {
  background: linear-gradient(135deg, #455a64 0%, #455a64 100%) !important;
}

/* ===== INPUT FOCUS STYLES ===== */
.v-text-field--outlined >>> fieldset {
  border-color: rgba(0, 0, 0, 0.23);
  transition: border-color 0.2s;
}

.v-text-field--outlined:hover >>> fieldset {
  border-color: rgba(0, 0, 0, 0.87);
}

.v-text-field--outlined.v-input--is-focused >>> fieldset {
  border-width: 2px;
  border-color: #455a64 !important;
}

.v-text-field--outlined.error--text >>> fieldset {
  border-color: #f44336 !important;
}

/* ===== BUTTON HOVER EFFECTS ===== */
.v-btn {
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
  text-transform: none;
  letter-spacing: 0.5px;
}

.v-btn:hover:not(.v-btn--disabled) {
  transform: translateY(-1px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
}

.v-btn.v-btn--icon:hover {
  transform: scale(1.1);
}

/* ===== SCROLLBAR STYLES ===== */
::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

::-webkit-scrollbar-track {
  background: #f5f5f5;
  border-radius: 4px;
}

::-webkit-scrollbar-thumb {
  background: #90a4ae;
  border-radius: 4px;
  transition: background 0.2s;
}

::-webkit-scrollbar-thumb:hover {
  background: #94a3b8;
}

/* Firefox */
* {
  scrollbar-width: thin;
  scrollbar-color: #90a4ae #f5f5f5;
}

/* ===== LOADING OVERLAY ===== */
.v-data-table__wrapper {
  position: relative;
}

.v-data-table--loading {
  position: relative;
}

.v-data-table--loading::after {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(255, 255, 255, 0.8);
  z-index: 10;
}

/* ===== ALERT STYLES ===== */
.v-alert {
  border-radius: 8px !important;
}

.v-alert--text {
  background-color: transparent !important;
}

.v-alert.error--text {
  background-color: #ffebee !important;
}

.v-alert.warning--text {
  background-color: #fff4dc !important;
}

.v-alert.info--text {
  background-color: #f5f5f5 !important;
}

.v-alert.success--text {
  background-color: #e8f5e9 !important;
}

/* ===== FILE INPUT STYLES ===== */
.v-file-input >>> .v-file-input__text {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* ===== RADIO GROUP STYLES ===== */
.v-radio-group {
  display: flex;
  justify-content: center;
}

.v-radio {
  margin: 0 8px;
}

/* ===== DIVIDER STYLES ===== */
.v-divider {
  border-color: rgba(0, 0, 0, 0.12);
}

/* ===== CARD STYLES ===== */
.v-card {
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.v-card.v-card--outlined {
  border: 1px solid rgba(0, 0, 0, 0.12);
}

/* ===== AVATAR STYLES ===== */
.v-avatar {
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

/* ===== LIST ITEM STYLES ===== */
.v-list-item {
  transition: background-color 0.2s;
}

.v-list-item:hover {
  background-color: rgba(0, 0, 0, 0.04);
}

/* ===== TOOLTIP STYLES ===== */
.v-tooltip__content {
  background: rgba(97, 97, 97, 0.95) !important;
  font-size: 12px;
  padding: 6px 12px;
  border-radius: 4px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
}

/* ===== SNACKBAR STYLES ===== */
.v-snackbar {
  font-weight: 500;
}

.v-snackbar__wrapper {
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.2) !important;
}

.v-snackbar--top {
  top: 80px;
}

/* ===== SELECT STYLES ===== */
.v-select >>> .v-select__selections {
  min-height: 40px;
}

.v-autocomplete >>> .v-autocomplete__content {
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

/* ===== MENU STYLES ===== */
.v-menu__content {
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

/* ===== PROGRESS LINEAR ===== */
.v-progress-linear {
  border-radius: 4px;
}

/* ===== EMBED PDF STYLES ===== */
embed[type="application/pdf"] {
  border: none;
}

/* ===== RESPONSIVE ADJUSTMENTS ===== */
@media (max-width: 960px) {
  .v-card-title.headline {
    font-size: 1.25rem !important;
  }

  .custom-table >>> thead th {
    font-size: 0.75rem;
    padding: 6px 8px;
  }

  .custom-table >>> tbody td {
    font-size: 0.75rem;
    padding: 6px 8px;
  }

  .v-btn.v-size--small {
    font-size: 0.75rem;
    padding: 0 8px;
  }

  .v-chip.v-size--x-small {
    font-size: 0.625rem;
    height: 20px;
  }

  .v-dialog {
    margin: 16px;
  }

  .v-toolbar-title {
    font-size: 1rem;
  }

  .v-list-item {
    padding: 8px 12px;
  }
}

@media (max-width: 600px) {
  .v-data-table >>> .v-data-footer {
    flex-wrap: wrap;
    justify-content: center;
  }

  .v-data-table >>> .v-data-footer__select {
    margin: 8px 0;
  }

  .v-data-table >>> .v-data-footer__pagination {
    margin: 8px 0;
  }
}

/* ===== PRINT STYLES ===== */
@media print {
  .v-toolbar,
  .v-btn,
  .v-chip.cursor-pointer,
  .v-snackbar,
  .v-dialog,
  .no-print {
    display: none !important;
  }

  .v-card {
    box-shadow: none !important;
    border: 1px solid #ddd;
  }

  .custom-table >>> tbody tr:hover {
    background-color: transparent !important;
  }

  body {
    background: white !important;
  }
}

/* ===== ANIMATION KEYFRAMES ===== */
@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes slideInRight {
  from {
    opacity: 0;
    transform: translateX(20px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}

@keyframes pulse {
  0%,
  100% {
    opacity: 1;
  }
  50% {
    opacity: 0.5;
  }
}

/* ===== FADE IN ANIMATION ===== */
.v-dialog > .v-card {
  animation: fadeIn 0.3s ease-out;
}

.v-snackbar__wrapper {
  animation: slideInRight 0.3s ease-out;
}

/* ===== LOADING ANIMATION ===== */
.v-progress-circular {
  animation: pulse 1.5s ease-in-out infinite;
}

/* ===== CUSTOM ELEVATION ===== */
.elevation-custom {
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.08), 0 4px 12px rgba(0, 0, 0, 0.08) !important;
}

/* ===== FOCUS VISIBLE ===== */
.v-btn:focus-visible,
.v-text-field:focus-visible,
.v-select:focus-visible {
  outline: 2px solid #455a64;
  outline-offset: 2px;
}

/* ===== DISABLED STATE ===== */
.v-btn--disabled {
  opacity: 0.5 !important;
  cursor: not-allowed !important;
}

.v-text-field--disabled >>> input,
.v-select--disabled >>> .v-select__selections {
  cursor: not-allowed;
  color: rgba(0, 0, 0, 0.38) !important;
}

/* ===== ERROR STATE ===== */
.error--text .v-input__slot {
  background-color: #ffebee !important;
}

.error--text >>> .v-messages__message {
  color: #f44336 !important;
  font-size: 0.75rem;
  margin-top: 4px;
}

/* ===== SUCCESS STATE ===== */
.success--text .v-input__slot {
  background-color: #e8f5e9 !important;
}

/* ===== CUSTOM CONTAINER PADDING ===== */
.pa-1 {
  padding: 4px !important;
}

.pa-2 {
  padding: 8px !important;
}

.pa-3 {
  padding: 12px !important;
}

.pa-4 {
  padding: 16px !important;
}

.pa-5 {
  padding: 20px !important;
}

.pa-6 {
  padding: 24px !important;
}

/* ===== MARGIN UTILITIES ===== */
.ma-1 {
  margin: 4px !important;
}

.ma-2 {
  margin: 8px !important;
}

.ma-3 {
  margin: 12px !important;
}

.ma-4 {
  margin: 16px !important;
}

/* ===== TEXT UTILITIES ===== */
.text-truncate {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.font-weight-bold {
  font-weight: 700 !important;
}

.font-weight-medium {
  font-weight: 500 !important;
}

/* ===== BORDER UTILITIES ===== */
.border-left {
  border-left: 4px solid currentColor;
}

.border-top {
  border-top: 4px solid currentColor;
}

/* ===== Z-INDEX MANAGEMENT ===== */
.v-dialog {
  z-index: 200 !important;
}

.v-snackbar {
  z-index: 250 !important;
}

.v-menu__content {
  z-index: 220 !important;
}

/* ===== CUSTOM COLORS ===== */
.primary--text {
  color: #455a64 !important;
}

.success--text {
  color: #2e7d32 !important;
}

.warning--text {
  color: #A86400 !important;
}

.error--text {
  color: #f44336 !important;
}

.info--text {
  color: #455a64 !important;
}

/* ===== BACKGROUND COLORS ===== */
.bg-primary {
  background-color: #455a64 !important;
}

.bg-success {
  background-color: #2e7d32 !important;
}

.bg-warning {
  background-color: #A86400 !important;
}

.bg-error {
  background-color: #f44336 !important;
}

.bg-info {
  background-color: #455a64 !important;
}

/* ===== OPACITY UTILITIES ===== */
.opacity-50 {
  opacity: 0.5 !important;
}

.opacity-75 {
  opacity: 0.75 !important;
}

/* ===== TRANSITION UTILITIES ===== */
.transition-all {
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;
}

.transition-fast {
  transition: all 0.15s ease-in-out !important;
}

/* ===== CURSOR UTILITIES ===== */
.cursor-default {
  cursor: default !important;
}

.cursor-not-allowed {
  cursor: not-allowed !important;
}

.cursor-move {
  cursor: move !important;
}

/* ===== OVERFLOW UTILITIES ===== */
.overflow-auto {
  overflow: auto !important;
}

.overflow-hidden {
  overflow: hidden !important;
}

.overflow-x-auto {
  overflow-x: auto !important;
}

.overflow-y-auto {
  overflow-y: auto !important;
}

/* ===== POSITION UTILITIES ===== */
.position-relative {
  position: relative !important;
}

.position-absolute {
  position: absolute !important;
}

.position-fixed {
  position: fixed !important;
}

/* ===== DISPLAY UTILITIES ===== */
.d-block {
  display: block !important;
}

.d-inline-block {
  display: inline-block !important;
}

.d-flex {
  display: flex !important;
}

.d-none {
  display: none !important;
}

/* ===== FLEX UTILITIES ===== */
.flex-wrap {
  flex-wrap: wrap !important;
}

.justify-center {
  justify-content: center !important;
}

.justify-end {
  justify-content: flex-end !important;
}

.justify-space-between {
  justify-content: space-between !important;
}

.align-center {
  align-items: center !important;
}

.align-start {
  align-items: flex-start !important;
}

.align-end {
  align-items: flex-end !important;
}

/* ===== GAP UTILITIES (for flex containers) ===== */
.gap-1 {
  gap: 4px;
}

.gap-2 {
  gap: 8px;
}

.gap-3 {
  gap: 12px;
}

.gap-4 {
  gap: 16px;
}

/* ===== END OF STYLES ===== */
</style>
